import styles from './DateTag.module.scss';

export const DateTag = ({ date }: { date: string }) => {
	return <span className={styles.DateTag}>{date}</span>;
};
